import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DB } from '../firebase'

// import './attendance.css'
import Calendar from './Calendar'
import { useAuthContext } from './contexts/AuthContext'
// import ZoomingAnimation from './partials/ZoomingAnimation'

// const dummyDB = [
//     {
//         date: new Date(2021, 1),
//         '01022021': {
//             date: new Date(2021, 1, 1),
//             st_id_12: true,
//             st_id_34: true,
//             st_id_56: false,
//             st_id_78: true
//         },
//         '02022021': {
//             date: new Date(2021, 1, 2),
//             st_id_12: true,
//             st_id_34: true,
//             st_id_56: false,
//             st_id_78: true
//         }
//     },
//     {
//         date: new Date(2021, 2),
//         '01032021': {
//             date: new Date(2021, 2, 1),
//             st_id_12: true,
//             st_id_56: false,
//             st_id_78: true
//         },
//         12032021: {
//             date: new Date(2021, 2, 12),
//             st_id_12: true,
//             st_id_34: true,
//             st_id_56: false,
//             st_id_78: true
//         },
//         '02032021': {
//             date: new Date(2021, 2, 2),
//             st_id_12: true,
//             st_id_34: true,
//             st_id_56: false,
//             st_id_78: true
//         }
//     }
// ]

function Attendance() {
    const [loading, setLoading] = useState(true)
    const [attendanceList, setAttendanceList] = useState([])

    const { userDetails } = useAuthContext()

    // batch, st_id

    useEffect(() => {
        !!userDetails &&
            DB.collection('attendance')
                .where('batch', '==', userDetails?.batch.batchName)
                .orderBy('date', 'desc')
                .onSnapshot((querySnapshot) => {
                    var attandance = []
                    querySnapshot.forEach((doc) => {
                        attandance.push(doc.data())
                    })
                    setAttendanceList(attandance)
                })
    }, [userDetails])

    return (
        <Container>
            <Heading>Attendance</Heading>

            <Calendar fetchList={attendanceList} studentId={userDetails?.uid} />
            {/* )}
            {loading && <ZoomingAnimation />} */}
        </Container>
    )
}

export default Attendance

const Container = styled.div`
    padding-top: 4.5rem;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 0;
    font-size: 24px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`
